import { render, staticRenderFns } from "./NoTagsView.vue?vue&type=template&id=39c4907e&scoped=true&"
import script from "./NoTagsView.vue?vue&type=script&lang=ts&"
export * from "./NoTagsView.vue?vue&type=script&lang=ts&"
import style0 from "./NoTagsView.vue?vue&type=style&index=0&id=39c4907e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c4907e",
  null
  
)

export default component.exports